var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiscover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 24,
    viewBox: "0 0 38 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "discoverbadge-a",
    x1: "75.555%",
    x2: "40.992%",
    y1: "90.012%",
    y2: "35.896%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F89F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "25.02%",
    stopColor: "#F79A20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "53.31%",
    stopColor: "#F68D20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "61.96%",
    stopColor: "#F58720"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.32%",
    stopColor: "#F48120"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F37521"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "discoverbadge-b",
    x1: "70.098%",
    x2: "19.584%",
    y1: "89.284%",
    y2: "-9.451%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F58720"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "35.87%",
    stopColor: "#E16F27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "70.3%",
    stopColor: "#D4602C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "98.16%",
    stopColor: "#D05B2E"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0.13 0.19L37.86 0.19 37.86 24.21 0.14 24.21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F48120",
    d: "M37.73,13.19 C37.73,13.19 27.42,20.46 8.54,23.72 L37.73,23.72 L37.73,13.19 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M37.86,0.00987248046 L0,0.00987248046 L0,24 L38,24 L38,-3.19744231e-14 L37.86,-3.19744231e-14 L37.86,0.00987248046 Z M37.73,0.276429453 C37.73,0.542986425 37.73,23.4570136 37.73,23.7235705 C37.46,23.7235705 0.55,23.7235705 0.28,23.7235705 C0.28,23.4570136 0.28,0.542986425 0.28,0.276429453 C0.55,0.276429453 37.45,0.276429453 37.73,0.276429453 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M3.32 7.17L1.75 7.17 1.75 12.67 3.32 12.67C4.15 12.67 4.75 12.47 5.28 12.04 5.91 11.52 6.28 10.74 6.28 9.93 6.27 8.3 5.06 7.17 3.32 7.17zM4.58 11.31C4.24 11.61 3.81 11.75 3.11 11.75L2.82 11.75 2.82 8.11 3.11 8.11C3.8 8.11 4.22 8.23 4.58 8.55 4.95 8.88 5.17 9.39 5.17 9.92 5.17 10.45 4.95 10.98 4.58 11.31zM6.77 7.17H7.84V12.67H6.77zM10.46 9.28C9.82 9.04 9.63 8.88 9.63 8.59 9.63 8.24 9.97 7.98 10.43 7.98 10.75 7.98 11.02 8.11 11.29 8.43L11.85 7.7C11.39 7.3 10.84 7.09 10.23 7.09 9.26 7.09 8.51 7.77 8.51 8.67 8.51 9.43 8.86 9.82 9.86 10.18 10.28 10.33 10.49 10.43 10.6 10.49 10.81 10.63 10.92 10.83 10.92 11.06 10.92 11.51 10.57 11.84 10.09 11.84 9.58 11.84 9.17 11.58 8.92 11.11L8.23 11.78C8.72 12.51 9.32 12.83 10.13 12.83 11.24 12.83 12.03 12.09 12.03 11.02 12.05 10.13 11.68 9.73 10.46 9.28zM12.38 9.93C12.38 11.55 13.65 12.8 15.28 12.8 15.74 12.8 16.14 12.71 16.62 12.48L16.62 11.22C16.19 11.65 15.81 11.82 15.33 11.82 14.25 11.82 13.48 11.04 13.48 9.92 13.48 8.86 14.27 8.03 15.28 8.03 15.79 8.03 16.18 8.21 16.62 8.65L16.62 7.39C16.15 7.15 15.76 7.05 15.3 7.05 13.69 7.05 12.38 8.33 12.38 9.93zM25.14 10.87L23.67 7.17 22.5 7.17 24.83 12.81 25.41 12.81 27.78 7.17 26.62 7.17zM28.27 12.67L31.31 12.67 31.31 11.74 29.34 11.74 29.34 10.26 31.24 10.26 31.24 9.33 29.34 9.33 29.34 8.11 31.31 8.11 31.31 7.17 28.27 7.17zM35.56 8.8C35.56 7.77 34.85 7.18 33.61 7.18L32.02 7.18 32.02 12.68 33.09 12.68 33.09 10.47 33.23 10.47 34.71 12.68 36.03 12.68 34.3 10.36C35.11 10.19 35.56 9.64 35.56 8.8zM33.4 9.71L33.09 9.71 33.09 8.04 33.42 8.04C34.09 8.04 34.45 8.32 34.45 8.86 34.45 9.41 34.09 9.71 33.4 9.71z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.91,
    cy: 9.94,
    r: 2.93,
    fill: "url(#discoverbadge-a)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.91,
    cy: 9.94,
    r: 2.93,
    fill: "url(#discoverbadge-b)",
    opacity: 0.65
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M36.75,7.5425 C36.75,7.33416667 36.575,7.23 36.3,7.23 L35.9,7.23 L35.9,8.23 L36.2,8.23 L36.2,7.83416667 L36.55,8.23 L36.9,8.23 L36.5,7.81333333 C36.65,7.7925 36.75,7.68833333 36.75,7.5425 Z M36.25,7.68833333 L36.2,7.68833333 L36.2,7.4175 L36.25,7.4175 C36.4,7.4175 36.475,7.45916667 36.475,7.5425 C36.475,7.64666667 36.4,7.68833333 36.25,7.68833333 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M36.35,6.99 C35.9392857,6.99 35.6,7.32928571 35.6,7.74 C35.6,8.15071429 35.9392857,8.49 36.35,8.49 C36.7607143,8.49 37.1,8.15071429 37.1,7.74 C37.1,7.32928571 36.7607143,6.99 36.35,6.99 Z M36.35,8.365 C36.0285714,8.365 35.7428571,8.09714286 35.7428571,7.74 C35.7428571,7.40071429 36.0107143,7.115 36.35,7.115 C36.6714286,7.115 36.9392857,7.40071429 36.9392857,7.74 C36.9392857,8.07928571 36.6714286,8.365 36.35,8.365 Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscover);
export default __webpack_public_path__ + "static/media/Discover.3841c256.svg";
export { ForwardRef as ReactComponent };